import React from 'react';
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import Token from "@material-ui/icons/AssignmentTurnedIn";
import UpdateIcon from "@material-ui/icons/Info";
import {appHelpers} from "../../_helpers";

export const SummaryCard = ({ passengerCount, classes, billablePax, outstandingPax, Amount}) =>
    {
       return  (
           <GridContainer>
               <GridItem xs={12} sm={6} md={4}>
                   <Card className={'dashboard-card'}>
                       <CardHeader color="regional" stats icon className={'dashboard-header'}>
                           <CardIcon color="regional">
                               <Token/>
                           </CardIcon>
                           <p className={`${classes.cardCategory} dashboard-category`}>Utilized Amount</p>
                           <h3 className={`${classes.cardTitle} dashboard-title`}>&#36;{appHelpers.numberWithCommasOnly(Amount)}</h3>
                           <span className="paragraph-end">&nbsp;</span>
                       </CardHeader>
                       <CardFooter stats className={'card-footer'}>
                           <div className={classes.stats}>
                               {/*<UpdateIcon />*/}
                               {/*Last 24 Hours*/}
                               &nbsp;
                               &nbsp;
                           </div>
                       </CardFooter>
                   </Card>
               </GridItem>
               <GridItem xs={12} sm={6} md={4}>
                   <Card className={'dashboard-card'}>
                       <CardHeader color="regional" stats icon className={'dashboard-header'}>
                           <CardIcon color="regional">
                               <Passenger />
                           </CardIcon>
                           <p className={`${classes.cardCategory} dashboard-category`}>Billable Passengers</p>
                           <h3 className={`${classes.cardTitle} dashboard-title`}> {appHelpers.numberWithCommasOnly(billablePax)} </h3>
                           <span className="paragraph-end">&nbsp;</span>
                       </CardHeader>
                       <CardFooter stats className={'card-footer'}>
                           <div className={classes.stats}>
                               <UpdateIcon />
                               out of {appHelpers.numberWithCommasOnly(passengerCount)}
                           </div>
                       </CardFooter>
                   </Card>
               </GridItem>
               <GridItem xs={12} sm={6} md={4}>
                   <Card className={'dashboard-card'}>
                       <CardHeader color="danger" stats icon className={'dashboard-header'}>
                           <CardIcon color="danger">
                               <Passenger />
                           </CardIcon>
                           <p className={`${classes.cardCategory} dashboard-category`}>Outstanding Passengers</p>
                           <h3 className={`${classes.cardTitle} dashboard-title`}>{appHelpers.numberWithCommasOnly(outstandingPax)}</h3>
                           <span className="paragraph-end">&nbsp;</span>
                       </CardHeader>
                       <CardFooter stats className={'card-footer'}>
                           <div className={classes.stats}>
                               {/*<UpdateIcon />*/}
                               {/*Last 24 Hours*/}
                               &nbsp;
                               &nbsp;
                           </div>
                       </CardFooter>
                   </Card>
               </GridItem>
           </GridContainer>
       )
    };




// WEBPACK FOOTER //
// ./src/Regional-Views/PSCUtilization/SummaryCard.js